"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEMO_VIDEO_ID = exports.DEMO_CHANNEL_ID = void 0;
exports.DEMO_CHANNEL_ID = 'a1ca9dac7ee44d52a41868329471105b';
exports.DEMO_VIDEO_ID = 'c01fe227bbde48ddb51fb744ba8a4b75';
//# sourceMappingURL=demo.js.map